<div id="borrowing-facility" class="watermark">
  <div class="container-fluid px-lg-5 py-4">
    <div class="row">
      <div class="col-12">
        <h2 class="title mb-4">Borrowing Facility</h2>
      </div>

      <div class="col-12">
        <p class="inner-lead">
          Numbers of Documents Permitted To Be Borrowed At A Time:
        </p>

        <div class="table-responsive mb-4">
          <table class="table table-bordered table-hover align-middle">
            <thead class="table-light">
              <tr>
                <th>Category of Library Members</th>
                <th>Numbers of Documents Permitted</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>UG Students</td>
                <td>2</td>
                <td>14 Days</td>
              </tr>
              <tr>
                <td>PG Students</td>
                <td>4</td>
                <td>14 Days</td>
              </tr>
              <tr>
                <td>Teaching Staff</td>
                <td>10</td>
                <td>30 Days</td>
              </tr>
              <tr>
                <td>Non-Teaching Staff</td>
                <td>5</td>
                <td>30 Days</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="inner-lead">
          <strong>Note:</strong> In case of loss of your library card, it will be re-issued with a fine of ₹100/-.
        </p>
        <p class="inner-lead">
          Students can borrow books related to competitive exams. But Journals and Magazines can only be
          consulted inside the library.
        </p>
      </div>
    </div>
  </div>
</div>
